import {
  withTranslation,
} from 'react-i18next';

import GroupFieldsView from './GroupFieldsView';

const TranslatedComponent = withTranslation()(GroupFieldsView);

const Component = TranslatedComponent;

export default Component;
